import { Mask } from '@/utils/Masks/types';
import { FormControl, FormErrorMessage } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { validateEmailDomain } from '@/utils/Validators/Email';

type ValidateTypes = Partial<Record<Mask, RegExp>>;

const FormControlComponent: React.FC<{
  children: React.ReactElement;
  isInvalid?: boolean;
  mask?: Mask;
}> = ({ children, isInvalid, mask }) => {
  const [emailDomainError, setEmailDomainError] = useState<string | null>(null);
  const [isValidating, setIsValidating] = useState(false);

  const validateTypes: ValidateTypes = {
    EMAIL: /\w+@\w+\.\w+/,
  };

  const regexValidate =
    mask && RegExp(validateTypes[mask] as RegExp).test(children?.props?.value);

  const invalidValue = !!mask && children?.props?.value && !regexValidate;

  // Validação assíncrona de domínio de email
  useEffect(() => {
    const validateDomain = async () => {
      if (mask === 'EMAIL' && children?.props?.value && regexValidate) {
        setIsValidating(true);
        const isDomainValid = await validateEmailDomain(children.props.value);
        
        if (!isDomainValid) {
          setEmailDomainError('O domínio do email não existe ou é inválido');
        } else {
          setEmailDomainError(null);
        }
        setIsValidating(false);
      } else {
        setEmailDomainError(null);
      }
    };

    // Debounce para evitar muitas validações
    const timeoutId = setTimeout(() => {
      validateDomain();
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [mask, children?.props?.value, regexValidate]);

  const hasError = isInvalid || invalidValue || !!emailDomainError;
  const errorMessage = emailDomainError || (invalidValue ? `${mask} inválido` : 'Este campo é obrigatório');

  return (
    <FormControl isInvalid={hasError}>
      {children}
      <FormErrorMessage>
        {errorMessage}
      </FormErrorMessage>
    </FormControl>
  );
};

export default FormControlComponent;
